import React, { useState, useEffect } from 'react';
import Menu from '../Menu'; // Assuming you have a Menu component

const ClientsPage = () => {
  const [clients, setClients] = useState([]);
  const [allMsg, setAllMsg] = useState("");

  const getClientsMap = () => {
    console.log("Get clients map - WebSocket removed");
  };

  const sendMessageToAll = () => {
    console.log("Send to all - WebSocket removed");
    setAllMsg(""); // Clear the input after sending
  };

  const sendMessageToClient = (clientKey, message) => {
    console.log("Send to client - WebSocket removed");
  };

  const clearLog = () => {
    console.log("Clear log - WebSocket removed");
  };

  return (
    <>
      <Menu /> {/* Sidebar menu included */}
      <div className="content-wrapper" style={{ padding: '20px' }}>

        {/* Button to get client map */}
        <button className="btn btn-primary" onClick={getClientsMap} style={{ width: '15%', marginBottom: '20px' }}>
          Get Client Map
        </button>

        {/* Clear Log Button */}
        <button className="btn btn-danger" onClick={clearLog} style={{ width: '15%', marginLeft: '20px', marginBottom: '20px' }}>
          Clear Log
        </button>

        {/* Message Log Box */}
        <div style={{ backgroundColor: 'var(--surface2)', padding: '10px', borderRadius: '5px', maxHeight: '300px', overflowY: 'scroll', border: '1px solid var(--border)' }}>
          <p style={{ color: 'var(--text)' }}>WebSocket functionality has been removed</p>
        </div><br></br>

        {/* Input and button to send message to all clients */}
        <div className="form-group">
          <label>Message to All:</label>
          <input
            type="text"
            className="form-control"
            value={allMsg}
            onChange={(e) => setAllMsg(e.target.value)}
          />
        </div>
        <button className="btn btn-warning" onClick={sendMessageToAll} style={{ width: '100%', marginBottom: '20px' }}>
          Send to All
        </button>

        {/* Table to list clients and send individual messages */}
        <h4>Client list</h4><br></br>
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Client Key</th>
              <th>Message</th>
              <th>Send</th>
            </tr>
          </thead>
          <tbody>
            {clients.length > 0 ? (
              clients.map((clientKey, index) => (
                <tr key={index}>
                  <td>{clientKey}</td>
                  <td>
                    <input type="text" id={`msg-${clientKey}`} className="form-control" />
                  </td>
                  <td>
                    <button
                      className="btn btn-primary"
                      onClick={() =>
                        sendMessageToClient(
                          clientKey,
                          document.getElementById(`msg-${clientKey}`).value
                        )
                      }
                    >
                      Send
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: 'center' }}>
                  No clients connected
                </td>
              </tr>
            )}
          </tbody>
        </table>

      </div>
    </>
  );
};

export default ClientsPage;
